module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-keyvue-green.c5f7fdb5.png";